import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Card, CardContent } from "@/components/ui/card";
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '@/contexts/LanguageContext';

const Partners = () => {
  const { language } = useLanguage();
  const partners = [
    {
      id: 1,
      name: "UNITED PHARMA",
      logo: "/partners/logo1.png"
    },
    {
      id: 2,
      name: "LTC",
      logo: "/partners/logo2.png"
    },
    {
      id: 3,
      name: "SAIPH",
      logo: "/partners/logo3.png"
    },
    {
      id: 4,
      name: "BERG",
      logo: "/partners/logo4.png"
    },
    {
      id: 5,
      name: "TABUK",
      logo: "/partners/logo5.png"
    },
    {
      id: 6,
      name: "MS LAB",
      logo: "/partners/logo6.png"
    }
  ];

  return (
    <>
      <Helmet>
        <title>{language === 'en' ? 'Pharmaceutical Partners | LeaderProMed Mauritania' : 'Partenaires médicaux | LeaderProMed Mauritanie'}</title>
        <meta name="description" content={language === 'en' ? 'Meet our international pharmaceutical partners and laboratories working with LeaderProMed for drug registration, distribution, and regulatory affairs in Mauritania and North Africa.' : 'Découvrez nos partenaires et laboratoires pharmaceutiques internationaux en Mauritanie et Afrique du Nord, leaders dans l’enregistrement, la distribution et les affaires réglementaires.'} />
        <meta name="keywords" content={language === 'en' ? 'pharmaceutical partner, international laboratory, drug registration, pharmaceutical registration, regulatory affairs, Mauritania, Africa, LeaderProMed, B2B, distribution, healthcare, market access, licensing, pharma, medical partner' : 'partenaire pharmaceutique, laboratoire international, enregistrement médicament, enregistrement pharmaceutique, affaires réglementaires, Mauritanie, Afrique, LeaderProMed, B2B, distribution, santé, accès au marché, licence, pharma, partenaire médical'} />
        <meta property="og:title" content={language === 'en' ? 'Pharmaceutical Partners | LeaderProMed Mauritania' : 'Partenaires médicaux | LeaderProMed Mauritanie'} />
        <meta property="og:description" content={language === 'en' ? 'Meet our international pharmaceutical partners and laboratories working with LeaderProMed for drug registration, distribution, and regulatory affairs in Mauritania and North Africa.' : 'Découvrez nos partenaires et laboratoires pharmaceutiques internationaux en Mauritanie et Afrique du Nord, leaders dans l’enregistrement, la distribution et les affaires réglementaires.'} />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="min-h-screen flex flex-col">
        <Header />
        
        <main className="flex-grow container mx-auto px-4 py-8">
          <div className="text-center mb-10">
            <h1 className="text-4xl font-bold text-blue-600 mb-2">Nos Partenaires</h1>
            <div className="h-1 w-20 bg-blue-600 mb-4 mx-auto"></div>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Nous travaillons avec les laboratoires pharmaceutiques internationaux les plus réputés pour offrir des produits de qualité au marché mauritanien.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {partners.map((partner) => (
              <Card key={partner.id} className="hover:shadow-lg transition-shadow">
                <CardContent className="p-6">
                  <div className="flex flex-col items-center">
                    <div className="h-32 w-full flex items-center justify-center mb-4">
                      <img 
                        src={partner.logo} 
                        alt={partner.name}
                        className="max-h-full max-w-full object-contain"
                      />
                    </div>
                    <h3 className="text-xl font-semibold text-blue-600">{partner.name}</h3>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default Partners;
